// extracted by mini-css-extract-plugin
export default {"wrapper":"modal_wrapper__bDedB","open":"modal_open__YDIwg","modal":"modal_modal__uA2ql","close":"modal_close__9AnI2"};